import { PATHNAMES } from "src/constants/routes";
import { ReactComponent as SpiralIcon } from "src/assets/icons/spiral-filled.svg";
import { ReactComponent as SpiralOutlineIcon } from "src/assets/icons/spiral.svg";
import { ReactComponent as InquiriesIcon } from "src/assets/icons/inquiries.svg";
import { ReactComponent as InquiriesOutlineIcon } from "src/assets/icons/inquiries-outline.svg";
import { ReactComponent as ProfileIcon } from "src/assets/icons/profile.svg";
import { ReactComponent as ProfileOutlineIcon } from "src/assets/icons/profile-outline.svg";
import { ReactComponent as SignUpOutlineIcon } from "src/assets/icons/sign-up-outline.svg";
import { ReactComponent as FavoriteIcon } from "src/assets/icons/bookmark.svg";
import { ReactComponent as FavoriteOutlineIcon } from "src/assets/icons/bookmark-outline.svg";
import { ReactComponent as WatchlistOutlineIcon } from "src/assets/icons/eye.svg";
import { ReactComponent as WatchlistIcon } from "src/assets/icons/eye-filled.svg";

import { IMenuItem } from "./types";
import { mobMenuTrns } from "./trns";

export const MOB_MENU_ITEMS: IMenuItem[] = [
  {
    id: "1",
    slug: "clones",
    title: {
      i18nKey: mobMenuTrns.clones,
    },
    path: PATHNAMES.CLONES,
    icon: SpiralOutlineIcon,
    activeIcon: SpiralIcon,
  },
  {
    id: "2",
    slug: "inquiries",
    title: {
      i18nKey: mobMenuTrns.inquiries,
    },
    path: PATHNAMES.INQUIRIES,
    icon: InquiriesOutlineIcon,
    activeIcon: InquiriesIcon,
  },
  {
    id: "3",
    slug: "cabinet",
    title: {
      i18nKey: mobMenuTrns.cabinet,
    },
    path: PATHNAMES.MY_CLONES,
    icon: ProfileOutlineIcon,
    activeIcon: ProfileIcon,
  },
  {
    id: "4",
    slug: "favourites",
    title: {
      i18nKey: mobMenuTrns.favourites,
    },
    path: PATHNAMES.FAVORITES_CLONES,
    icon: FavoriteOutlineIcon,
    activeIcon: FavoriteIcon,
  },
  {
    id: "5",
    slug: "watchlist",
    title: {
      i18nKey: mobMenuTrns.watchlist,
    },
    path: PATHNAMES.FAVOURITE_INQUIRIES,
    icon: WatchlistOutlineIcon,
    activeIcon: WatchlistIcon,
  },
  {
    id: "6",
    slug: "login",
    title: {
      i18nKey: mobMenuTrns.login,
    },
    path: PATHNAMES.LOGIN,
    icon: ProfileOutlineIcon,
  },
  {
    id: "7",
    slug: "sign-up",
    title: {
      i18nKey: mobMenuTrns.signUp,
    },
    path: PATHNAMES.REGISTRATION,
    icon: SignUpOutlineIcon,
  },
];
